<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top>
            {{ text }}
            <v-btn color="pink" text @click="msg = false">Close</v-btn>
        </v-snackbar>
        <v-card>
            <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
                <v-flex xs12>
                    <v-btn fab x-small @click="$router.go(-1)">
                        <v-icon>navigate_before</v-icon>
                    </v-btn>
                </v-flex>

                <v-flex xs12 md1 class="mb-2">
                    <v-btn
                        fab
                        small
                        @click="printTable()"
                        class="ml-8 white--text"
                        color="#2b6993"
                        elevation="4"
                        absolute
                        right
                    >
                        <v-icon>print</v-icon>
                    </v-btn>
                </v-flex>

                <v-flex xs12>
                    <h3 class="text-center mb-5">Client Competency Tests</h3>
                    <v-divider class="ml-4 mr-4 mb-3"></v-divider>
                </v-flex>

                <v-row>
                    <v-card class="ma-3 pa-3" elevation="0">
                        <v-row>
                            <v-col cols="12">
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-menu
                                            ref="calendarMenu"
                                            v-model="calendarMenu"
                                            :close-on-content-click="false"
                                            :return-value.sync="date"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="reportFilters.startDate"
                                                    label="Start Date"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :rules="requiredField"
                                                    clearable
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="reportFilters.startDate"
                                                no-title
                                                scrollable
                                                :rules="requiredField"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="calendarMenu = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="$refs.calendarMenu.save(date)"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-menu
                                            ref="calendar2Menu"
                                            v-model="calendar2Menu"
                                            :close-on-content-click="false"
                                            :return-value.sync="date"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="reportFilters.endDate"
                                                    label="End Date"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :rules="requiredField"
                                                    clearable
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="reportFilters.endDate"
                                                no-title
                                                scrollable
                                                :rules="requiredField"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="calendar2Menu = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="$refs.calendar2Menu.save(date)"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12" md="4">
                                        <v-select
                                            label="Client Status"
                                            :items="clientStatuses"
                                            v-model="reportFilters.clientStatus"
                                            clearable
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" md="4">
                                        <v-select
                                            label="Select Program"
                                            :items="programs"
                                            item-text="Name"
                                            item-value="Name"
                                            v-model="reportFilters.program"
                                            clearable
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" md="4">
                                        <v-select
                                            label="Select Client"
                                            :items="filteredClients"
                                            item-text="Name"
                                            item-value="Name"
                                            v-model="reportFilters.client"
                                            clearable
                                        ></v-select>
                                    </v-col>


                                    <v-col cols="12" md="4">
                                        <v-select
                                            label="Staff Status"
                                            :items="staffStatuses"
                                            v-model="reportFilters.staffStatus"
                                            clearable
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" md="4">
                                        <v-select
                                            label="Select Staff"
                                            :items="filteredEmployees"
                                            item-text="Name"
                                            item-value="_id"
                                            v-model="reportFilters.StaffID"
                                            clearable
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="1">
                                        <v-btn block class="mt-4 mb-4 pl-5" @click="testQuery()"
                                        >Search
                                        </v-btn
                                        >
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-row>

                <v-flex xs12 class="pa-2">
                    <v-data-table
                        :headers="headers"
                        :items="tests"
                        sort-by="Date"
                        sort-desc
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading Client Comp Test"
                        :items-per-page="100"
                    >
                        <template v-slot:item.Date="{ item }">
                            {{ formatDate(item.Date) }}
                        </template>
                        <template v-slot:item.select="{ item }">
                            <v-btn
                                x-small
                                class="white--text"
                                color="#2b3990"
                                @click="viewTest(item)"
                            >
                                view
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-card>
        <div id="print">
            <report-header>
                <h2>Client Competency Tests Report</h2>
            </report-header>
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="tests"
                        sort-by="Date"
                        sort-desc
                        class="elevation-0"
                        :loading="isLoading"
                        loading-text="Loading Client Comp Test"
                        height="auto"
                        hide-default-footer
                        disable-pagination
                    />
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import DateTimeUtil from "../../../utils/date-time.util.js";
import ReportHeader from '@/components/Report/ReportHeader.vue';
import {STATUS_ARRAY, STATUSES as UserStatus} from '../../enums/UserStatusEnum';
import {STATUSES as StaffStatus} from "../../enums/StaffStatusEnum";
import ReportFilters from '@/mixins/reportFilters.js';
// import Foot from '../components/Footer'

const url = require("../../client_config/config").url;

export default {
    mixins: [
      ReportFilters,
    ],
    components: {
        ReportHeader
    },
    data: () => ({
        headers: [
            {
                text: "Date",
                align: "start",
                sortable: true,
                value: "Date",
            },
            {text: "Staff Name", value: "Employee.Name"},
            {text: "Client Name", value: "ClientName"},
            {text: "Program", value: "Program"},
            {text: "", value: "select"},

            //   { text: "Notes", value: "Notes" },
            //   { text: "Signature", value: "Signature" },
        ],
        e6: 1,
        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        employees: [],
        tests: [],
        clients: [],
        programs: [],
        menu: false,
        calendarMenu: false,
        calendar2Menu: false,
        report: "",
        clientName: "",
        staff: "",
        isLoading: false,
        titleForm: "New Client Test",
        requiredField: [(v) => !!v || "This is required"],
        state: localStorage.getItem("userState"),
        msg: false,
        text: "",
        query: [],
        dialog: false,
        editTest: false,
        newTest: false,
        newDate: "",
        newClientName: "",
        newProgram: "",
        newConditions: "",
        newFunctions: "",
        newReadPCSP: "",
        newReadCSS: "",
        newG1: "",
        newG1S1: "",
        newG1S2: "",
        newG1S3: "",
        newG1S4: "",
        newG2: "",
        newG2S1: "",
        newG2S2: "",
        newG2S3: "",
        newG2S4: "",
        newG3: "",
        newG3S1: "",
        newG3S2: "",
        newG3S3: "",
        newG3S4: "",
        newG4: "",
        newG4S1: "",
        newG4S2: "",
        newG4S3: "",
        newG4S4: "",
        newStrengths: "",
        newPreferences: "",
        newInterests: "",
        newRecreation: "",
        newFinancial: "",
        newHealthConcerns: "",
        newPrecautions: "",
        newDiet: "",
        newIll: "",
        newEating: "",
        newGoals: "",
        newMed1: "",
        newPurp1: "",
        newSide1: "",
        newMed2: "",
        newPurp2: "",
        newSide2: "",
        newMed3: "",
        newPurp3: "",
        newSide3: "",
        newMed4: "",
        newPurp4: "",
        newSide4: "",
        newMed5: "",
        newPurp5: "",
        newSide5: "",
        newMed6: "",
        newPurp6: "",
        newSide6: "",
        newMed7: "",
        newPurp7: "",
        newSide7: "",
        newMed8: "",
        newPurp8: "",
        newSide8: "",
        newMed9: "",
        newPurp9: "",
        newSide9: "",
        newMed10: "",
        newPurp10: "",
        newSide10: "",
        newMed11: "",
        newPurp11: "",
        newSide11: "",
        newMed12: "",
        newPurp12: "",
        newSide12: "",
        newMed13: "",
        newPurp13: "",
        newSide13: "",
        newMed14: "",
        newPurp14: "",
        newSide14: "",
        newMed15: "",
        newPurp15: "",
        newSide15: "",
        newMed16: "",
        newPurp16: "",
        newSide16: "",
        newMed17: "",
        newPurp17: "",
        newSide17: "",
        newMed18: "",
        newPurp18: "",
        newSide18: "",
        newMed19: "",
        newPurp19: "",
        newSide19: "",
        newMed20: "",
        newPurp20: "",
        newSide20: "",
        newReadRR: "",
        newRights: "",
        newSupervision: "",
        newBCS: "",
        newReadBCS: "",
        newTar1: "",
        newDef1: "",
        newTar2: "",
        newDef2: "",
        newTar3: "",
        newDef3: "",
        newTar4: "",
        newDef4: "",
        newTar5: "",
        newDef5: "",
        newTar6: "",
        newDef6: "",
        newTrig1: "",
        newTrig2: "",
        newTrig3: "",
        newTrig4: "",
        newTrig5: "",
        newTrig6: "",
        newInt1: "",
        newInt2: "",
        newInt3: "",
        newInt4: "",
        newInt5: "",
        newInt6: "",
        newPhase1: "",
        newBehavior1: "",
        newResp1: "",
        newPhase2: "",
        newBehavior2: "",
        newResp2: "",
        newPhase3: "",
        newBehavior3: "",
        newResp3: "",
        newPhase4: "",
        newBehavior4: "",
        newResp4: "",
        newPhase5: "",
        newBehavior5: "",
        newResp5: "",
        newPhase6: "",
        newBehavior6: "",
        newResp6: "",
        newReinforce: "",
        newRelationship: "",
        newRedirection: "",
        newReadCCP: "",
        newRole1: "",
        newName1: "",
        newRole2: "",
        newName2: "",
        newRole3: "",
        newName3: "",
        newRole4: "",
        newName4: "",
        newRole5: "",
        newName5: "",
        newRole6: "",
        newName6: "",
        newRole7: "",
        newName7: "",
        newRole8: "",
        newName8: "",
        newRole9: "",
        newName9: "",
        newRole10: "",
        newName10: "",
        userRole: localStorage.getItem("userRole"),
        clientStatuses: STATUS_ARRAY,
        staffStatuses: STATUS_ARRAY,
        reportFilters:  {
            startDate: '',
            endDate: '',
            StaffID: '',
            staffStatus: '',
            clientStatus: '',
            program: '',
            client: '',
        },
        reportFilterName: 'ReportFilters_ClientCompentencyTest',
    }),

    computed: {
        filteredClients() {
            let clients = this.clients;
            let clientStatus = this?.reportFilters.clientStatus;
            let program = this?.reportFilters.program;

            if (clientStatus != "" && clientStatus) {
                clients = clients.filter((client) => client.Status == clientStatus)
            }

            if (program != "" && program) {
                clients = clients.filter((client) => client.Program.includes(program))
            }

            return clients;
        },

        filteredEmployees() {
            const employees = this.employees;
            const staffStatus = this.reportFilters.staffStatus;

            if (staffStatus === UserStatus.INACTIVE) {
                return employees.filter(
                    (employee) => employee.Status == StaffStatus.TERMINATED
                );
            }

            if (staffStatus === UserStatus.ACTIVE) {
                return employees.filter(
                    (employee) =>
                        employee.Status == StaffStatus.FULL_TIME ||
                        employee.Status == StaffStatus.PART_TIME
                );
            }
            return employees;
        },

    },

    created() {
        this.getEmployees();
        this.getClients();
        this.getPrograms();
        this.reportFilters = this.getReportFilters(this.reportFilterName) ?? this.reportFilters;
    },

    watch: {
      reportFilters: {
        handler(newVal) {
          this.setReportFilters(this.reportFilterName, newVal);
        },
        deep: true
      }
    },

    methods: {
        initialize() {
            this.tests = [];
        },

        async getEmployees() {
            let endpoint = "";
            const companyIds = localStorage.getItem("userCompanies");

            endpoint = `${url}/users/state/${this.state}`;

            await axios
                .get(endpoint, {
                    params: {
                        Company: JSON.parse(companyIds),
                    },
                })
                .then((res) => {
                    this.employees = res.data.users;
                });
        },

        async getPrograms() {
            const companyIds = localStorage.getItem("userCompanies");

            await axios
                .get(`${url}/units/state/${this.userState}`, {
                    params: {
                        Company: JSON.parse(companyIds),
                    },
                })
                .then((res) => {
                    this.programs = res.data.units;
                });
        },

        testQuery() {
            this.tests = [];
            this.isLoading = true;

            const companyIds = localStorage.getItem("userCompanies");

            let queryParams = {
                startDate: this.reportFilters.startDate,
                endDate: this.reportFilters.endDate,
                Program: this.reportFilters.program,
                ClientName: this.reportFilters.client,
                Employee: this.reportFilters.StaffID,
                Company: JSON.parse(companyIds),
                staffStatus: this.reportFilters.staffStatus
            };

            try {
                axios
                    .get(`${url}/clientTests/query/test`, {
                        params: queryParams,
                    })
                    .then((res) => {
                        var temp = res.data.tests;
                        for (var i = 0; i < temp.length; i++) {
                            if (this.state == temp[i].Employee?.State) {
                                this.tests.push(temp[i]);
                            }
                        }
                        this.isLoading = false;
                    });
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },

        getStaffID(item) {
            this.staff = item.EmployeeID;
            window.localStorage.setItem("staffId", this.staff);
            console.log(this.staff);
        },

        viewTest(item) {
            this.$router.push({
                path: `/compTests/view/${item._id}`,
                query: {viewingTest: true},
            })
        },

        async getClients() {
            let params = {};
            let endpoint = `${url}/clients`;

            const companyIds = localStorage.getItem("userCompanies");

            if (this.userRole !== "SuperAdministrator") {
                // If not SuperAdmin, filter fetched data based on the user's Company
                params["Company:in"] = JSON.parse(companyIds);

                // If user belongs to Admin group but its user role is not Administration,
                // filter fetched data based on the user's State
                if (this.userRole !== "Administration") {
                    params["State"] = this.userState;
                }
            }

            await axios.get(endpoint, {params}).then((res) => {
                this.clients = res.data.clients;
            });
        },

        getUnits: function () {
            axios.get(`${url}/units`).then(async (res) => {
                this.units = res.data.units;
            });
        },

        formatDate(date) {
            return DateTimeUtil.toLocalDate(date);
        },

        printTable() {
            window.print();
        },
    },
};
</script>
<style>
#print {
    display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}

@media print {
    #print {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;
    }

    nav.v-navigation-drawer,
    header.v-toolbar,
    button.v-btn,
    div.v-card {
        display: none;
        border: none;
    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }
}
</style>
